import { render, staticRenderFns } from "./CartInfos.vue?vue&type=template&id=3ef19844&scoped=true&"
import script from "./CartInfos.vue?vue&type=script&lang=js&"
export * from "./CartInfos.vue?vue&type=script&lang=js&"
import style0 from "./CartInfos.vue?vue&type=style&index=0&id=3ef19844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef19844",
  null
  
)

export default component.exports